import script from "./CallDispositionRequiredModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallDispositionRequiredModal.vue?vue&type=script&lang=ts&setup=true"

import "./CallDispositionRequiredModal.vue?vue&type=style&index=0&id=03842d2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03842d2f"]])

export default __exports__